import { render } from "./NewSubscription.vue?vue&type=template&id=167b8a1c"
import script from "./NewSubscription.vue?vue&type=script&lang=js"
export * from "./NewSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src676743866/src/profileSite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__